// import { Background } from './../../games/crash/gameelements/Background';
import { Theme } from './ITheme';

const crashTheme: Theme = {
  colors: {
    background: '#0D1117',
    background2: '#5e6062ff',
    background3: '#1e1e1e',
    background4: '#bbc0c5ff',
    qbet: '#484b4cff',
    slider: '#353636ff',
    primary: '#FF4757',
    secondary: '#232628ff',
    success: '#28A745',
    danger: '#cb011a',
    warning: '#d07206',
    text: '#FFFFFF',
    overlay: 'rgba(0, 0, 0, 0.5)',
    border: '#FFFFFF33',
    betborder: '#b2f2a3',
    betborderPress: '#1c7430',
    betbutton: '#00c417ff',
    autoplayBtBg: '#1D7ACA',
    autoplayBtBgborder: '#46c0f2',
    autoplayBgHover: '#007bff',
    betCancelHover: '#f7001f',
    betCancelPress: '0 0 0 0.2rem #e1536180',
    betCashHover: '#f58708',
    betCashPress: '0 0 0 0.2rem #deaa0c80',
    cancelborder: '#ff7171',
    cashoutborder: '#ffbd71',
    betCashPressMobile: '#d39e00',
    text2: '#ede7e7e0',
    betButtonHover: '#36cb12',
    betButtonPressMobile: '#1e7e34',
    betCancelPressMobile: '#bd2130',
    betButtonPress: '0 0 0 0.2rem #48b46180',
    stake: '#FF4757', // stake color
    betHover: '#FF475766',
    // StartPress: '#deaa0c80',
    // CancelBorderPress: '0 0 0 0.2rem #e1536180',
    // CashoutBorderPress: '0 0 0 0.2rem rgba(255, 183, 51, 0.5)',
  },
  fonts: {
    primary: 'Roboto, sans-serif',
    secondary: 'Arial, sans-serif',
    button: 'Roboto, sans-serif',
  },
  uiElements: {
    button: { borderRadius: '8px', padding: '10px 16px', fontSize: '14px' },
    card: { borderRadius: '12px', shadow: '0 4px 6px rgba(0,0,0,0.1)' },
    modal: { borderRadius: '16px', background: '#1a1a1a' },
    spacing: { padding: '16px', margin: '16px' },
  },
};

export default crashTheme;
